import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as moment from 'moment';
import {bookingFormCommon} from './c005-bookingform-common';

export class ibeStandaloneIframe {    
    loadIBEPopUp(): void {       
        let $el: any = $('#ibe-standalone-iframe');
        $el.css('border-bottom', 'none');
        let $closeIbe: any = $el.find('.close-booking');
        $('#mini-ibe-cta-button').val('1');
        $closeIbe.hide();
        $closeIbe.on('click', (e: any) => {
            $.magnificPopup.close();
        });
        var options1 = $el.find('.payment-method-options li label');
        var values1 = $.map(options1, function (option: any) {
            if (option.innerText.trim() != 'Card / Cash') {
                option.classList.add('hide');
            }
        });                    
        $el.find('.trip-type--container .roundTheWorldTrip').removeClass('visible-lg');
        $el.find('.trip-type--container .roundTheWorldTrip').addClass('hide');
        $el.find('.trip-type--container .sideTrip').addClass('hide');
        $el.find('.trip-type--container .ibe_sideTrip').addClass('hide');
        $el.find('#isSideTripEnable').val('No');
        $el.find('.payment-type-container').addClass('hide');

        let bcommon = new bookingFormCommon();
        let urlParams = bcommon.getUrlVars(window.location.href);

        if (urlParams.promoenable && urlParams.promoenable === 'true') {
            $el.find('.couponCode').removeClass('hide');
            if (urlParams.promocode) {                
                $el.find('.couponCode input').addClass('input-focused');
			    $('.booking-form--title',$el.find('.couponCode input').parent()).addClass('input-filled');   
                $el.find('.couponCode input').val(urlParams.promocode);
            }
        } else {
            $el.find('.couponCode').addClass('hide');
        }
       
        if (window.innerWidth < 768) {
            $el.css({ 'padding': '0', 'height': '100%' });  
            $el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
            $el.find('#mobile-bookflight--container').css({ 'height': '100%' });            
            $el.find('.trip-type--container').css({ 'margin-bottom': '10px' });
        }       
        $('.iframe-banner-container').on('click', function (e: any) {
            if ($('#ui-datepicker-div').datepicker('widget').is(':visible') || $('#ibe-standalone-iframe').attr('data-isopen') == 'true') {
                e.preventDefault();
                e.stopPropagation();
                $('#ibe-standalone-iframe').removeAttr('data-isopen'); 
            }
        });
    
    }
}

let scope: Element = document.querySelector('.iframe-container');
if (scope) {
    try {
        let ibestandaloneIframe = new ibeStandaloneIframe();
        ibestandaloneIframe.loadIBEPopUp();
    } catch (e) { console.error(e); }
}